import React from 'react';
import Layout from '../components/common/Layout';

const PrivacyPolicy = () => {
  return (
    <Layout title="Política de Privacidad" showBackButton={true}>
      <div className="flex flex-col items-center pt-8 pb-12">
        <div className="w-full max-w-md card">
          <h1 className="text-3xl font-bold mb-4 text-sangre-600 text-center">Política de Privacidad</h1>
          <p className="mb-4 text-gray-600 text-base text-justify">
            Tu privacidad es importante para nosotros. Esta aplicación recopila y utiliza información personal solo para los fines necesarios para el funcionamiento y mejora del servicio.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2 text-sangre-600">Información que recopilamos</h2>
          <ul className="list-disc pl-6 mb-4 text-gray-600 text-base">
            <li>Datos de autenticación (por ejemplo, correo electrónico de Google).</li>
            <li>Información de uso de la aplicación.</li>
            <li>Datos de salud proporcionados voluntariamente.</li>
          </ul>
          <h2 className="text-xl font-semibold mt-6 mb-2 text-sangre-600">Uso de la información</h2>
          <ul className="list-disc pl-6 mb-4 text-gray-600 text-base">
            <li>Mejorar la experiencia del usuario.</li>
            <li>Personalizar recomendaciones.</li>
            <li>Garantizar la seguridad de la cuenta.</li>
          </ul>
          <h2 className="text-xl font-semibold mt-6 mb-2 text-sangre-600">Compartir información</h2>
          <p className="mb-4 text-gray-600 text-base text-justify">
            No compartimos tu información personal con terceros, salvo obligación legal o para el funcionamiento esencial del servicio.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2 text-sangre-600">Tus derechos</h2>
          <p className="mb-4 text-gray-600 text-base text-justify">
            Puedes solicitar la eliminación de tus datos o modificar tu información personal en cualquier momento desde la configuración de tu perfil.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2 text-sangre-600">Contacto</h2>
          <p className="text-gray-600 text-base text-justify">
            Si tienes dudas sobre esta política, contáctanos a través del soporte de la aplicación.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy; 